import { IconTrash } from './icons';

/**
 * Destructive action behind a native confirm. Every delete in this app is
 * immediate and cannot be undone, so all of them go through here.
 */
export function DeleteButton({
  confirm,
  onConfirm,
  label,
  className = 'btn-icon-danger',
  disabled,
}: {
  /** The question. Name the thing being deleted, not just "Are you sure?". */
  confirm: string;
  onConfirm: () => void;
  /** `aria-label` — the button's only content is an icon. */
  label: string;
  className?: string;
  /** For a thing that can't go yet; say why somewhere on the page. */
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={className}
      aria-label={label}
      disabled={disabled}
      onClick={() => {
        if (window.confirm(confirm)) onConfirm();
      }}
    >
      <IconTrash />
    </button>
  );
}
